import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";
import { getNewFilteredProducts } from "@/services/api/newListingApis";

export const useNewGetAllFilteredProducts = ({
  id,
  brandName,
  pageNumber,
  stockStatus,
  value,
  order,
  search,
  categorySlug,
}: {
  id?: number;
  brandName?: string;
  pageNumber?: number;
  stockStatus?: string;
  value?: string;
  order?: string;
  search?: string;
  categorySlug?: string;
}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GETNEWFILTEREDPRODUCTS, id, brandName, pageNumber, stockStatus, value, order, search, categorySlug],
    queryFn: () => getNewFilteredProducts({ id, brandName, pageNumber, stockStatus, value, order, search, categorySlug }),
  });
};
